import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { usePublicScreenContext } from "../../context/PublicScreenContext";
import { createChecksum } from "../../commonFunctions/fileFolderConfig";
import { useTreeContext } from "../../context/TreeDataContext";
import { useAxiosContext } from "../../context/AxiosContext";
import { useAppOrgContext } from "../../context/AppOrgContext";
import { useNavigationContext } from "../../context/NavigationContext";
import Loader from "../../Layouts/Loader/Loader";
import PublicScreenRenderer from "./PublicScreenRenderer";
import PublicFormRenderer from "./PublicFormRenderer";
import { useFormContext } from "../../context/FormContext";
import { getFolderFileById } from "../../utils/treeData/folderEditorUtils";

const PublicScreenViewer = () => {
  const { publicAccessExplorerData } = useTreeContext();
  const [isLoading, setIsLoading] = useState(false);
  const { axiosInstance, handleError } = useAxiosContext();
  const { currentChecksum } = useAppOrgContext();
  const { getInitialRederConfig } = useNavigationContext();

  const { setLayouts, selectedPublicScreen, setSelectedPublicScreen, setAllPublicForm } = usePublicScreenContext();
  const { renderFieldsData, setRenderFieldsArray } = useFormContext();

  const { publicId } = useParams();
  const navigate = useNavigate();

  const fetchSingleScreen = async (id, parentData) => {
    try {
      setIsLoading(true);
      setLayouts([]);
      let checksumConfig = {};
      if (parentData === "publicform") {
        const { data: formData } = await axiosInstance.get(`/public-screen-form/${id}`);
        getInitialRederConfig("publicform", formData);
        checksumConfig = {
          fields: formData.fields,
          custom_js: formData.custom_js,
          submit_button: formData.submit_button
        };

        if (!formData.fields) {
          setRenderFieldsArray([]);
          renderFieldsData.current = {};
        } else {
          const allFields = formData.fields || [];
          const newRenderArray = allFields.map((field, i) => {
            renderFieldsData.current[field.id] = field;
            return {
              w: 12,
              h: 1,
              x: 0,
              y: i,
              i: field.id
            };
          });
          setRenderFieldsArray(newRenderArray);
        }
      } else {
        const { data: screenData } = await axiosInstance.get(`/public-screens/${id}`);
        getInitialRederConfig("publicscreen", screenData);
        checksumConfig = {
          config: screenData.config
        };
      }
      const checksum = createChecksum(checksumConfig);
      currentChecksum.current = checksum;
      setIsLoading(false);
    } catch (error) {
      handleError(error);
    }
  };

  const initialRendering = async () => {
    if (!publicAccessExplorerData) return;
    const file = getFolderFileById(publicAccessExplorerData, publicId);
    // setCurrentScreenData({ id: "" });
    if (file) {
      setSelectedPublicScreen({
        id: file.id,
        name: file.name,
        parentData: file.parentData,
        // type: file.name === "header" ? "header" : "page"
        type: "page"
      });

      await fetchSingleScreen(file.id, file.parentData);
    } else {
      navigate("../");
    }
  };

  const renderPublicAccess = () => {
    const accesspage = selectedPublicScreen.parentData;
    switch (accesspage) {
      case "publicform":
        return <PublicFormRenderer />;

      default:
        return <PublicScreenRenderer />;
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: allForms } = await axiosInstance.get(`/public-screen-form`);
        setAllPublicForm(allForms);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPublicScreen.parentData]);

  useEffect(() => {
    initialRendering();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [publicId, publicAccessExplorerData]);

  return (
    <div className="content_main_section">
      {isLoading ? <Loader /> : selectedPublicScreen.id && renderPublicAccess()}
    </div>
  );
};

export default PublicScreenViewer;
